module.exports = __webpack_public_path__ + "img/logo.b47e7334.png";